import { datadogLogs } from '@datadog/browser-logs';

import { environment } from '@watershed/config/env';
import { getPublicRuntimeConfig } from '@watershed/config/utils/publicRuntimeConfig';

if (
  typeof window !== 'undefined' &&
  getPublicRuntimeConfig('NEXT_PUBLIC_ENVIRONMENT') === 'production'
) {
  const clientToken = getPublicRuntimeConfig('NEXT_PUBLIC_DD_CLIENT_TOKEN');
  if (clientToken) {
    datadogLogs.init({
      clientToken,
      site: 'datadoghq.com',
      forwardConsoleLogs: 'all',
      forwardReports: 'all',
      service: getPublicRuntimeConfig('NEXT_PUBLIC_APPLICATION'),
      version: getPublicRuntimeConfig('NEXT_PUBLIC_CLIENT_VERSION'),
      env: environment(),
      sampleRate: 100,
      beforeSend: (event) => {
        if (event.message.includes('X-Goog-Signature')) {
          const message = event.message.replace(
            /(X-Goog-Signature=)[^&]*/,
            '$1<redacted>'
          );

          event.message = message;
        }
      },
    });
  }
}
